<ng-container *ngIf="model">
  <div id="share-group-and-members-container" class="container">
    <!--share with groups/members-->
    <div id="share-group-and-members" class="option-container" [style.padding-bottom]="isEditor ? '16px' : null">
      <div class="main">
        <div class="text-content padding-content">
          <div *ngIf="model?.warningMessage" class="warning">
            <div class="warning-icon"><div class="icon">!</div></div>
            <div class="warning-message">{{ model?.warningMessage }}</div>
          </div>
          <div *ngIf="model.updateGroupAndMembers; else groupsTitle" class="group-and-member-new-title-section">
            <span class="title">{{ model.updateGroupAndMembers }}</span>
          </div>
          <span class="small-subtitle" *ngIf="isEditor"> {{ model.descriptionShareGroups }}</span>
          <div class="auto-complete-container" *ngIf="isEditor" [ngClass]="{ margin: model.descriptionShareGroups }">
            <div class="auto-complete-content">
              <u-auto-complete
                #autoComplete
                class="share-options-auto-complete"
                label="name"
                [suggestionItems]="suggestions"
                [placeholder]="model?.inputPlaceholder || 'Add a group or a member'"
                [multiple]="true"
                [group]="true"
                [width]="showShareButton ? '352px' : '439px'"
                [groupItemsField]="'items'"
                [selectedItems]="selectedSuggestions"
                [displayDismissButton]="false"
                [filterInvoker]="filterTags"
                (onFocus)="sendImpressionEvent(viewType === 'share' ? 'search_member' : 'search_verifier')"
                (onChange)="onSelectedSuggestions($event)"
                [disabled]="disabled"
              >
                <ng-template let-value pTemplate="selectedItem">
                  <span>{{ value?.name }}</span>
                </ng-template>

                <ng-template let-value pTemplate="item">
                  <div
                    class="item-container"
                    [ngClass]="{ 'item-disable': value.disable }"
                    [ngStyle]="{ width: showShareButton ? '342px' : '429px' }"
                  >
                    <div class="item-content">
                      <div class="item-profile">
                        <u-icon
                          class="item-avatar"
                          [model]="{ type: 'img', value: { lightUrl: value.picture } }"
                          [fallback]="MEMBER_ICON_FALLBACK"
                          *ngIf="value?.name !== 'No results' && value.picture"
                        ></u-icon>
                        <div *ngIf="value?.name !== 'No results' && !value.picture" class="item-avatar label">
                          {{ value.name[0] | uppercase }}
                        </div>
                      </div>
                      <div class="item-details">
                        <div class="name">
                          {{ value.name }}
                          <div *ngIf="value.type === 'external-group'">
                            <ng-container *ngTemplateOutlet="externalGroup"></ng-container>
                          </div>
                        </div>
                        <span>{{ value.email || (value.membersCount ? value.membersCount + ' members' : '') }}</span>
                      </div>
                    </div>
                    <div class="item-label" *ngIf="value.isAdmin || value.isOwner">
                      {{ value.isOwner ? 'Owner' : 'Admin' }}
                    </div>
                  </div>
                </ng-template>

                <ng-template let-group pTemplate="group">
                  <span>{{ group.name }}</span>
                </ng-template>
              </u-auto-complete>
              <div class="change-access" [class]="'dropdown-0'" *ngIf="model.displayPermissionOption && scopePermissionOptions.length > 1">
                <ng-container
                  *ngTemplateOutlet="selectedAccess; context: { autoComplete: true, workspace: false, indexInvited: -1 }"
                ></ng-container>
              </div>
            </div>
            <u-button
              *ngIf="showShareButton"
              [label]="'Share'"
              type="primary"
              [disabled]="!selectedSuggestions.length"
              [styles]="{ width: '84px', height: '32px' }"
              (onClick)="onClickInvite($event)"
            >
            </u-button>
          </div>
          <div *ngIf="model.specialMessage" class="special-message">
            <u-icon
              class="special-message-icon"
              [model]="{ type: 'font', value: model.specialMessageIcon }"
              [styles]="{ fontSize: '14px' }"
            ></u-icon>
            <span> {{ model.specialMessage }}</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="isMaxHightPopup && viewType !== 'verification'; else content">
      <ng-scrollbar visibility="hover" [style.height]="heightScrollPopup">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </ng-scrollbar>
    </div>

    <ng-template #content>
      <!--shared groups/members-->
      <ng-container *ngIf="viewType !== 'verification'">
        <ng-container
          *ngTemplateOutlet="invited; context: { invited: creator, isCreator: true, indexInvited: -1, type: 'account' }"
        ></ng-container>
      </ng-container>

      <div *ngIf="owOrAdmins?.count">
        <ng-container
          *ngTemplateOutlet="
            selectedAdmins;
            context: {
              adminsCount: owOrAdmins.count,
            }
          "
        ></ng-container>
      </div>

      <div *ngFor="let invite of invitedSuggestions || []; index as i">
        <ng-container
          *ngTemplateOutlet="
            invited;
            context: {
              invited: invite?.invited,
              tooltipInfo: workspacePermission?.shared && workspacePermission.scope === 'write' && invite.scopePermissions === 'read',
              indexInvited: i,
              type: invite?.type,
            }
          "
        ></ng-container>
      </div>

      <!--share with workspace-->
      @if (model.displayWorkspacePermissions !== false && model.displayWorkspaceViewPermissions !== false) {
        @if (model.displayWorkspaceViewPermissions) {
          <div class="main center">
            <ng-container *ngTemplateOutlet="workspaceContent"></ng-container>
            <div class="action-workspace">
              <span class="container-side-title">Viewers</span>
            </div>
          </div>
        } @else {
          <div class="option-workspace-container">
            <div class="main">
              <ng-container *ngTemplateOutlet="workspaceContent"></ng-container>
              <div class="action-workspace">
                <u-toggle-switch [checked]="workspacePermission?.shared" (onChange)="onToggleButtonChange()"> </u-toggle-switch>
                <div
                  class="change-access"
                  [class]="'dropdown-' + (dropdownList?.length - 1)"
                  *ngIf="model.displayPermissionOption && workspacePermission?.shared"
                >
                  <div *ngIf="scopePermissionOptions.length > 1; else singleOption">
                    <ng-container
                      *ngTemplateOutlet="selectedAccess; context: { autoComplete: false, workspace: true, indexInvited: -1 }"
                    ></ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="ws-massage" *ngIf="!model.displayPermissionOption">
              <span class="small-subtitle" [innerHTML]="WS_MESSAGE"></span>
            </div>
          </div>
        }
      }

      <ng-template #workspaceContent>
        <div class="text-content ws-content">
          <span class="option-workspace-title">Everyone at {{ workspace?.name }}</span>
          <div class="subtitle">
            <u-icon
              class="company-icon"
              [model]="{ type: 'font', value: 'icon-settings-company' }"
              [styles]="{ fontSize: '16px' }"
            ></u-icon>
            <span class="workspace-members-title">
              {{ (workspace?.accounts ? workspace.accounts?.length : 0) + ' Workspace members' }}</span
            >
          </div>
        </div>
      </ng-template>
    </ng-template>
  </div>
</ng-container>

<ng-template #selectedAccess let-autoComplete="autoComplete" let-workspace="workspace" let-indexInvited="indexInvited">
  <u-dropdown
    [options]="scopePermissionOptions"
    [selectedValue]="getSelectedOption(autoComplete, workspace, indexInvited)"
    optionLabel="label"
    optionalSubLabel="subLabel"
    [inTable]="true"
    [indicationSelected]="true"
    [appendTo]="'body'"
    [endListElement]="indexInvited > -1 ? 'Remove' : null"
    (onChangeEndList)="onDeleteInvited(indexInvited)"
    (onChange)="onChangeScopePermissions($event, autoComplete, workspace, indexInvited)"
    (onShow)="onShowDropdown(autoComplete ? 0 : indexInvited > -1 ? indexInvited + 1 : dropdownList.length - 1)"
  >
  </u-dropdown>
</ng-template>

<ng-template
  #invited
  let-invited="invited"
  let-isCreator="isCreator"
  let-tooltipInfo="tooltipInfo"
  let-indexInvited="indexInvited"
  let-type="type"
>
  <div class="main center">
    <div class="content">
      <div class="user-avatar-member-container">
        <u-icon
          *ngIf="invited?.picture; else defaultPicture"
          [model]="{ type: 'img', value: { lightUrl: invited?.picture } }"
          [fallback]="MEMBER_ICON_FALLBACK"
          class="user-avatar-member-wrapper"
        ></u-icon>
        <ng-template #defaultPicture>
          <ng-container
            *ngTemplateOutlet="
              defaultAvatar;
              context: { backgroundColor: invitedSuggestions[indexInvited]?.backgroundColor, name: invited?.name || invited?.firstName }
            "
          ></ng-container>
        </ng-template>
      </div>
      <div class="text-content user-text-content">
        <span class="user">
          <div class="user-title" *ngIf="type === 'account'; else group">
            {{ invited?.firstName || '' }} {{ invited?.lastName || '' }}{{ currentUserId === invited?.userId ? ' (You)' : '' }}
          </div>
          <ng-template #group>
            <div class="user-title">{{ invited?.name || '' }}</div>
            <div *ngIf="type === 'external-group'">
              <ng-container *ngTemplateOutlet="externalGroup"></ng-container>
            </div>
          </ng-template>
        </span>
        <span class="user-sub-title">{{ invited?.email || (invited?.membersCount ? invited?.membersCount + ' members' : '') }}</span>
      </div>
    </div>

    <ng-container *ngIf="isCreator; else changeAccessRef">
      <span class="container-side-title">Creator</span>
    </ng-container>

    <ng-template #changeAccessRef>
      <div class="change-access" [class]="'dropdown-' + (indexInvited + 1)">
        <u-icon
          *ngIf="tooltipInfo"
          [model]="{ type: 'font', value: 'icon-info' }"
          [styles]="{ color: 'var(--yellow-600)' }"
          [pTooltip]="accessTooltip"
          tooltipPosition="bottom"
          tooltipStyleClass="u-tooltip"
        ></u-icon>
        <div *ngIf="model.displayPermissionOption">
          <ng-container *ngTemplateOutlet="selectedAccess; context: { autoComplete: false, workspace: false, indexInvited }"></ng-container>
        </div>
        <div *ngIf="!model.displayPermissionOption && !model.displayPermissionAndRemove && viewType === 'share'">
          <ng-container *ngTemplateOutlet="removeInvited; context: { indexInvited }"></ng-container>
        </div>
        <div *ngIf="model.displayPermissionAndRemove" class="permission-remove">
          <ng-container *ngTemplateOutlet="displayPermissionAndRemove; context: { indexInvited }"></ng-container>
        </div>
      </div>
    </ng-template>
  </div>
</ng-template>

<ng-template #defaultAvatar let-backgroundColor="backgroundColor" ; let-name="name">
  <div class="user-profile" [style.background-color]="backgroundColor">
    {{ name?.[0]?.toUpperCase() }}
  </div>
</ng-template>

<ng-template #selectedAdmins let-adminsCount="adminsCount">
  <div class="main center">
    <div class="content">
      <ng-container *ngTemplateOutlet="defaultAvatar; context: { backgroundColor: 'var(--color-primary)', name: 'admin' }"></ng-container>
      <div class="text-content user-text-content">
        <span class="user">
          <div class="user-title">{{ workspace?.name }} WS Admins</div>
        </span>
        <span
          class="user-sub-title mouse-clickable"
          (mouseover)="adminTooltipOp.show($event, actualTarget)"
          (mouseleave)="onHidePanel(adminTooltipOp)"
          >{{ adminsCount + ' admins' }}</span
        >
      </div>
    </div>
    <span class="container-side-title">{{ owOrAdmins.label }}</span>
  </div>
</ng-template>

<p-overlayPanel #adminTooltipOp [showTransitionOptions]="'0.1.5s'" [hideTransitionOptions]="'0ms'">
  <avatar-list-tooltip
    [items]="(owOrAdmins?.avatarList || []).slice(0, ADMINS_TOOLTIP_LIMIT)"
    [sizeAvatarTooltip]="'16px'"
    [footer]="
      owOrAdmins?.avatarList?.length - ADMINS_TOOLTIP_LIMIT > 0
        ? '+ ' + (owOrAdmins?.avatarList?.length - ADMINS_TOOLTIP_LIMIT) + ' more admins'
        : null
    "
  ></avatar-list-tooltip>
</p-overlayPanel>

<ng-template #removeInvited let-indexInvited="indexInvited">
  <span class="remove-invited" (click)="onDeleteInvited(indexInvited)">Remove</span>
</ng-template>

<ng-template #displayPermissionAndRemove let-indexInvited="indexInvited">
  <span *ngIf="invitedSuggestions[indexInvited]?.scopePermissions !== ''; else warning">{{
    convertToDisplayScope(invitedSuggestions[indexInvited]?.scopePermissions)
  }}</span>
  <u-icon
    *ngIf="isEditor"
    [ngClass]="{ 'close-icon': !disabled }"
    (click)="onDeleteInvited(indexInvited)"
    [model]="{ type: 'font', value: 'icon-Windows-close' }"
    [styles]="{ fontSize: '8px', color: 'var(--color-text-tertiary);' }"
  ></u-icon>
</ng-template>

<ng-template #warning>
  <div class="warning-icon" [pTooltip]="warningTooltip" tooltipPosition="bottom" tooltipStyleClass="u-tooltip">
    <div class="icon">!</div>
  </div>
</ng-template>

<ng-template #externalGroup>
  <div class="external-group" [pTooltip]="externalTooltip" tooltipPosition="top" tooltipStyleClass="u-tooltip">
    <u-icon class="external-icon" [model]="{ type: 'font', value: 'icon-slack1' }"></u-icon>
    <span class="external-text">EXTERNAL</span>
  </div>
</ng-template>

<ng-template #singleOption>
  <span class="single-option container-side-title">{{ scopePermissionOptions[0]?.label }}</span>
</ng-template>
